import _ from 'lodash';
import React from 'react';
import { BenchmarkThresholdAttemptAuditMetadata } from '@scale/shared/types/corp/attemptAudit';
import { IInstructionItemJson } from '@scale/shared/types/instructionitem';
import { Chip } from 'design-system';

interface IThresholdAuditDescription {
  metadata: BenchmarkThresholdAttemptAuditMetadata;
  projectInstrItems: IInstructionItemJson[];
}

function IIThresholdAuditDescription({ metadata, projectInstrItems }: IThresholdAuditDescription) {
  const descriptionObj = _.mapValues(
    _.mapKeys(
      _.pickBy(metadata.workerInstrItemThresholds, _.identity),
      (meta, instructionItemID) => {
        const name = projectInstrItems.find(
          projectInstrItem => projectInstrItem._id === instructionItemID,
        )?.name;
        return name || instructionItemID;
      },
    ),
    (value: number) => value.toFixed(2),
  );
  return (
    <span>
      {_.map(descriptionObj, (value, key) => (
        <Chip size="small" key={key} label={[key, value && `(${value})`].join(' ')} />
      ))}
    </span>
  );
}

export default React.memo(IIThresholdAuditDescription);
